import { hasAccessToFeature } from './permissions';

const PROVIDED_VIDEOGAMES: { slug: VideogameSlug; name: string }[] = [
  { name: 'League of Legends', slug: 'league-of-legends' },
  { name: 'Counter Strike', slug: 'cs-go' },
  { name: 'Dota 2', slug: 'dota-2' },
  { name: 'Overwatch', slug: 'ow' },
  { name: 'Rocket League', slug: 'rl' },
  { name: 'Call of Duty', slug: 'cod-mw' },
  { name: 'Rainbow Six', slug: 'r6-siege' },
  { name: 'EA Sports FC', slug: 'fifa' },
  { name: 'Valorant', slug: 'valorant' },
  { name: 'King of Glory', slug: 'kog' },
  { name: 'Wild Rift', slug: 'lol-wild-rift' },
  { name: 'Starcraft 2', slug: 'starcraft-2' },
  { name: 'Starcraft Brood War', slug: 'starcraft-brood-war' },
  { name: 'eSoccer', slug: 'e-soccer' },
  { name: 'eBasketball', slug: 'e-basketball' },
  { name: 'eCricket', slug: 'e-cricket' },
  { name: 'Mobile Legends', slug: 'mlbb' }
];

const getProvidedVideogamesSlugs = () => PROVIDED_VIDEOGAMES.map(v => v.slug);

const EXTERNAL_PROVIDERS_VIDEOGAMES: VideogameSlug[] = ['e-soccer', 'e-basketball', 'e-cricket'];

function getVideogameName(videogameSlug: VideogameSlug): string | undefined {
  return PROVIDED_VIDEOGAMES.find(({ slug }) => slug === videogameSlug)?.name;
}

function isAvailableVideogame(videogameSlug: string | undefined): videogameSlug is VideogameSlug {
  return PROVIDED_VIDEOGAMES.some(({ slug }) => slug === videogameSlug);
}

const isCompetitorVideogame = (videogameSlug: VideogameSlug): boolean =>
  EXTERNAL_PROVIDERS_VIDEOGAMES.includes(videogameSlug);
const isPandascoreVideogame = (videogameSlug: VideogameSlug): boolean =>
  !isCompetitorVideogame(videogameSlug);

const canSeeExternalProvidesVideogames = (videogameList: VideogameSlug[] | undefined) =>
  !videogameList || videogameList?.some(videogame => isCompetitorVideogame(videogame));

const getAvailableVideogames = (videogameList: VideogameSlug[] | undefined) =>
  PROVIDED_VIDEOGAMES.filter(
    videogame =>
      !videogameList ||
      !!videogameList.find(availableVideogame => availableVideogame === videogame.slug)
  );

const getFilteredProvidedVideogames = (
  userType: UserType,
  videogameList: VideogameSlug[] | undefined,
  displayExternalProvidersMatches: boolean
) => {
  const availableVideogames = getAvailableVideogames(videogameList);

  const shouldNotFilter =
    hasAccessToFeature('EXTERNAL_PROVIDERS_MATCHES_BLUEPRINT', userType) &&
    displayExternalProvidersMatches;
  if (shouldNotFilter) {
    return availableVideogames;
  }
  return availableVideogames.filter(videogame => isPandascoreVideogame(videogame.slug));
};

const getAllVideogamesQueryList = (
  displayExternalProvidersMatches: boolean,
  videogameList: VideogameSlug[] | undefined
) =>
  displayExternalProvidersMatches &&
  (!videogameList || videogameList?.length === PROVIDED_VIDEOGAMES.length)
    ? ''
    : getAvailableVideogames(videogameList)
        .filter(videogame => isPandascoreVideogame(videogame.slug))
        .map(v => v.slug)
        .join(',');

export {
  PROVIDED_VIDEOGAMES,
  EXTERNAL_PROVIDERS_VIDEOGAMES,
  getVideogameName,
  isAvailableVideogame,
  getFilteredProvidedVideogames,
  getAvailableVideogames,
  canSeeExternalProvidesVideogames,
  getProvidedVideogamesSlugs,
  isCompetitorVideogame,
  isPandascoreVideogame,
  getAllVideogamesQueryList
};
